import React from 'react';
import SearchBooks from "../GoogleBooks"

const LandingPage = () => (
  <div>
    <SearchBooks />
  </div>
);
 
export default LandingPage;